import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "21",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10.5 0C16.298 0 21 4.702 21 10.5S16.298 21 10.5 21a10.5 10.5 0 0 1-2.98-.43c1.31-1.24 1.81-3.245 2.23-5.325.86.492 1.32 1.008 2.416 1.086 4.045.294 6.303-3.811 5.752-7.604-.496-3.36-4.044-5.071-7.822-4.67-2.991.319-5.97 2.6-6.091 5.864-.079 1.993.763 3.487 2.773 3.907.23-.942.272-1.452.272-1.452l-.01-.01-.13-.13c-.252-.261-.766-.834-.834-1.234-.739-4.298 5.249-7.232 8.391-4.232 2.167 2.083.739 8.487-2.76 7.82-3.355-.636 1.64-5.731-1.036-6.733-2.174-.816-3.33 2.49-2.3 4.129-.57 2.65-1.754 5.158-1.457 8.385.2.073.402.14.605.2-.162.156-.339.299-.53.429a11.269 11.269 0 0 1-.075-.63C2.882 18.908 0 15.04 0 10.5 0 4.702 4.702 0 10.5 0Z",
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, null, -1)
  ])))
}
export default { render: render }